import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { RestApiBase } from '../../../shared/configurations/rest-api-base.config';
import { ResearchTopic } from '../../../shared/interfaces/research-topic.intreface';

@Injectable({ providedIn: 'root' })
export class DepositKeywordsService {
    private http = inject(HttpClient);

    getResearchTopics(researchTopicLookup: string) {
        return this.http.get<ResearchTopic[]>(RestApiBase.RESEARCH_TOPICS, {
            params: { researchTopicLookup },
        });
    }
}
